import { render, staticRenderFns } from "./PopoverMenuActionItem.vue?vue&type=template&id=43cefc87&"
import script from "./PopoverMenuActionItem.vue?vue&type=script&lang=js&"
export * from "./PopoverMenuActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports